import React from 'react';
import ContentPostDetail from '../components/content/ContentPostDetail';
import { newsService } from '../api';
import './InfoPages.css';

const NewsDetailPage = () => (
    <div className="info-page">
        <ContentPostDetail service={newsService} basePath="/news" />
    </div>
);

export default NewsDetailPage;
